import { useEffect, useRef, type ReactNode } from 'react'

export function Modal({ label, onClose, children }: { label: string; onClose: () => void; children: ReactNode }) {
  const dialogRef = useRef<HTMLDialogElement>(null)
  const previousFocus = useRef<HTMLElement | null>(null)
  const restored = useRef(false)

  useEffect(() => {
    const dialog = dialogRef.current
    if (!dialog) return

    previousFocus.current = document.activeElement instanceof HTMLElement ? document.activeElement : null
    restored.current = false
    if (!dialog.open) dialog.showModal()

    const firstControl = dialog.querySelector<HTMLElement>('button:not([disabled]), input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled]), a, [tabindex]:not([tabindex="-1"])')
    firstControl?.focus()

    return () => {
      if (dialog.open) dialog.close()
      if (!restored.current) {
        previousFocus.current?.focus({ preventScroll: true })
        restored.current = true
      }
    }
  }, [])

  return (
    <dialog
      ref={dialogRef}
      className="observation-sheet"
      aria-label={label}
      aria-modal="true"
      onCancel={(event) => {
        event.preventDefault()
        onClose()
      }}
    >
      {children}
    </dialog>
  )
}
